import React, { Fragment, useState, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import matchSorter from 'match-sorter';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {
    setProduct,
} from 'actions/product';
import { TIGHT_FIT_PARAM } from 'constants/System';

const ProductTable = () => {
    const dispatch = useDispatch();
    const productList = useSelector(state => state.products.productList);
    const selectedProduct = useSelector(state => state.products.selectedProduct);
    const width = useSelector(state => state.settings.width);
    const [selected, setSelected] = useState(0);

    useLayoutEffect(() => {
        const selected = productList.findIndex(entry => entry?.id === selectedProduct?.id) || 0;
        setSelected(selected);
    }, []);

    const styledSummaryColumn = (value) => {
        return <Fragment>
                <span className="d-inline-block text-black">
                    <div className="font-weight-bold">{value}</div>
                </span>
        </Fragment>;
    };
    const nameColumn = {
        Header: 'Name',
        id: 'name',
        accessor: d => d?.name,
        filterMethod: (filter, rows) =>
            matchSorter(rows, filter.value, { keys: ['name'] }),
        Cell: ({ value }) => {
            return styledSummaryColumn(value);
        },
        filterAll: true,
    };
    const descColumn = {
        Header: 'Description',
        id: 'desc',
        accessor: d => d?.description,
        filterMethod: (filter, rows) =>
            matchSorter(rows, filter.value, { keys: ['desc'] }),
        filterAll: true,
    };

    const columnsList = new Array();
    columnsList.push(nameColumn);
    if (width > TIGHT_FIT_PARAM) {
        columnsList.push(descColumn);
    }
    return (
        <div style={{ marginLeft: '10px', marginRight: '10px' }}>
            <ReactTable
                data={productList}
                filterable
                defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value}
                columns={[
                    {
                        columns: columnsList
                    }
                ]}
                defaultPageSize={10}
                getTrProps={(state, rowInfo) => {
                    if (rowInfo && rowInfo.row) {
                        return {
                            onClick: () => {
                                // console.log(JSON.stringify(rowInfo?.index));
                                dispatch(setProduct(rowInfo?.original?.id));
                                setSelected(rowInfo.index);
                            },
                            style: {
                                background: rowInfo.index === selected ? '#cfd8dc' : 'white',
                                color: rowInfo.index === selected ? 'black' : 'black'
                            }
                        };
                    } else {
                        return {};
                    }
                }}
            />
        </div>
    );
};

export default ProductTable;


// WEBPACK FOOTER //
// ./components/Agile/product/productTable/index.js